import type { FC } from "react";
import { Container, Row } from "react-grid-system";
import Subtitle from "../atoms/typography/Subtitle";
import { theme } from "../../theme";
import { HorizontalSpacer } from "../atoms/Spacers";
import { useTranslation } from "react-i18next";
import Body from "../atoms/typography/Body";
import { TakenIllustration } from "../atoms/illustrations/TakenIllustration";

const NotFoundPage: FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Container>
        <HorizontalSpacer spacing={4} />
        <Subtitle color={theme.colors.primary} textalign="center">
          {t("errors.somethingWentWrong")}
        </Subtitle>
        <HorizontalSpacer spacing={2} />
        <Body textalign="center">{t("errors.notFoundDescription")}</Body>
        <HorizontalSpacer spacing={2} />
        <Row justify="center">
          <TakenIllustration />
        </Row>
      </Container>
    </div>
  );
};

export default NotFoundPage;
